<template>
    <div id="main-menu-container" class="d-flex flex-column">
        <div id="menu-top" class="d-flex flex-column justify-content-center flex-fill">
            <ul>
                <component
                    :is="resolveNavItemComponent(item)"
                    v-for="item in items.top"
                    :key="item.header || item.title"
                    v-b-tooltip.hover.right="isVerticalMenuCollapsed ? $t(item.title) : ''"
                    :class="item.class"
                    :item="item"
                />
            </ul>
        </div>
        <div id="menu-bottom">
            <ul>
                <component
                    :is="resolveNavItemComponent(item)"
                    v-for="item in items.bottom"
                    :key="item.header || item.title"
                    v-b-tooltip.hover.right="isVerticalMenuCollapsed ? $t(item.title) : ''"
                    :class="item.class"
                    :item="item"
                />
            </ul>
        </div>
    </div>
</template>

<script>
import { VBTooltip } from "bootstrap-vue";
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { provide, ref } from "@vue/composition-api";

import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";
import VerticalNavMenuGroup from "../vertical-nav-menu-group/VerticalNavMenuGroup.vue";
import useVerticalNavMenu from "@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu";

export default {
    components: {
        VerticalNavMenuHeader,
        VerticalNavMenuLink,
        VerticalNavMenuGroup,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        items: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { isVerticalMenuCollapsed } = useVerticalNavMenu(props);

        provide("openGroups", ref([]));

        return {
            resolveNavItemComponent,
            isVerticalMenuCollapsed,
        };
    },
};
</script>
